module.exports = __webpack_public_path__ + "img/victory-banner.2eb51ed3.png";